import { combineReducers } from '@reduxjs/toolkit';
import { RootState } from '../domain/models/RootState';
import warehousesReducer from './warehouses/slice';
import drawersReducer from './drawers/slice';
import loansReducer from './loans/slice';
import loansP2PReducer from './loans_p2p/slice';
import loansP2PKeyReducer from './loans_p2p_key/slice';
import housekeysReducer from './housekeys/slice';
import typekeysReducer from './typekeys/slice';
import propertiesReducer from './properties/slice';
import drawersDivisionsReducer from './drawersdivisions/slice';
import usersReducer from './users/slice';
import { scanReducer } from './scan/slice';
import { renovationReducer } from './renovation/slice';
import authReducer from './auth/slice';
import dashboardReducer from './dashboard/slice';
import houseKeyCommentsReducer from './housekeys_comments/slice';
import timeZonesReducer from './time_zones/slice';
import returnsReducer from './returns/slice';

export const rootReducer: any = combineReducers<RootState>({
  //NOTA: Agregar todos los reducers
  dashboard: dashboardReducer,
  warehouses: warehousesReducer,
  drawers: drawersReducer,
  housekeys: housekeysReducer,
  type_keys: typekeysReducer,
  properties: propertiesReducer,
  drawers_divisions: drawersDivisionsReducer,
  users: usersReducer,
  loans: loansReducer,
  loans_p2p: loansP2PReducer,
  loans_p2p_key: loansP2PKeyReducer,
  scan: scanReducer,
  renovation: renovationReducer,
  housekey_comments: houseKeyCommentsReducer,
  auth: authReducer,
  timeZones: timeZonesReducer,
  returns: returnsReducer,
});
